import {ACTION_TYPES} from '../app.types';
import {SegmentModel} from './segment.model';
import {SegmentAction} from './segment.service';


export interface SegmentContainerState {
  segments: SegmentModel[],
  segmentsForValidation: SegmentModel[],
  error?: Error;
}

export const INITIAL_STATE: SegmentContainerState = {
  segments: [],
  segmentsForValidation: [],
  error: undefined,
};

export function segmentsContainer(state = INITIAL_STATE,
                                  action: SegmentAction = {type: '?'}) {

  const newState = {...state};
  switch (action.type) {
    case ACTION_TYPES.SEGMENT_LIST_GET:
      return {...newState, segments: action.segments};
    case ACTION_TYPES.SEGMENT_LIST_GET_FOR_VALIDATION:
      return {...newState, segmentsForValidation: action.segments};
    case ACTION_TYPES.SEGMENT_ERROR:
      return {...newState, error: action.error};
    default:
      return state;
  }

}

export const segmentListSelector = (state: any): SegmentModel[] => state.segmentsContainer.segments;
export const segmentListForValidationSelector = (state: any): SegmentModel[] => state.segmentsContainer.segmentsForValidation;
